import { NgModule } from '@angular/core';
import { FilterPipe } from './filter/filter';
import { NumberToArray } from './numberToArray/numberToArray';
import { SafeHtmlPipe } from './safeHtml/safeHtml';

@NgModule({
	declarations: [SafeHtmlPipe, FilterPipe, NumberToArray],
	imports: [],
	exports: [SafeHtmlPipe, FilterPipe, NumberToArray]
})

export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts